import { OctagonMinusIcon, RefreshCwIcon, ArrowRightIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/index';
import { Card } from '@/components/card';

interface NoAccessPageProps {
  redirectTo?: string;
}

export default function NoAccessPage({ redirectTo = '/' }: NoAccessPageProps) {
  const { t } = useTranslation('no-access');
  const navigate = useNavigate();

  return (
    <Card className="px-6 space-y-4 w-fit">
      <div className="flex items-start gap-4">
        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-red-100 text-red-700 shrink-0">
          <OctagonMinusIcon className="w-5 h-5" />
        </div>
        <div className="space-y-1">
          <h2 className="text-base font-semibold">{t('title')}</h2>
          <p className="text-sm text-muted-foreground">{t('message')}</p>
        </div>
      </div>

      <div className="flex items-center justify-end gap-4 flex-wrap">
        <Button
          variant="outline"
          IconPrefix={RefreshCwIcon}
          onClick={() => navigate(0)}
        >
          {t('refresh')}
        </Button>
        <Button
          variant="primary"
          IconPrefix={ArrowRightIcon}
          onClick={() => navigate(redirectTo)}
        >
          {t('go_to_allowed')}
        </Button>
      </div>
    </Card>
  );
}
